import "src/decidim/admin/proposal_infinite_edit";
import BudgetRuleTogglerComponent from "src/decidim/admin/budget_rule_toggler.component";
$(() => {
  const budgetRuleToggler = new BudgetRuleTogglerComponent({
    ruleCheckboxes: $("input[id^='component_settings_vote_rule_']")
  });
  budgetRuleToggler.run();
  const $readonlyContainer = $(".readonly_container input");
  $readonlyContainer.click((event) => {
    event.preventDefault();
    return false;
  });
  const $amendmentsEnabled = $("input#component_settings_amendments_enabled");
  if ($amendmentsEnabled.length > 0) {
    const $amendmentStepSettings = $(".amendments_wizard_help_text_container, .amendments_visibility_container, .amendment_creation_enabled_container, .amendment_reaction_enabled_container, .amendment_promotion_enabled_container");
    if ($amendmentsEnabled.is(":not(:checked)")) {
      $amendmentStepSettings.hide();
    }
    $amendmentsEnabled.click(() => {
      $amendmentStepSettings.toggle();
    });
  }
  const $attachmentsAllowedCheckbox = $("#component_settings_attachments_allowed");
  const $attachmentsHelpText = $(".attachments_allowed_container .help-text");
  if (!$attachmentsAllowedCheckbox.is(":checked")) {
    $attachmentsHelpText.hide();
  }
  $attachmentsAllowedCheckbox.on("change", () => {
    if ($attachmentsAllowedCheckbox.is(":checked")) {
      $attachmentsHelpText.show();
    } else {
      $attachmentsHelpText.hide();
    }
  });
});
